import {Integer} from 'platform/foundation';

import {FocusEventHandler, KeyboardEventHandler} from 'react';

import {Nullish, TestIdProps} from 'shared/web';

import {FormControlProps} from '../../types/FormControlProps';
import {LabelActions} from '../Label/LabelActions';

export type ToolbarOption =
  | 'bold'
  | 'italic'
  | 'underline'
  | 'strike'
  | 'header'
  | 'blockquote'
  | 'listOrdered'
  | 'listBullet'
  | 'align'
  | 'clean'
  | 'emoji';

export interface RichTextProps
  extends Omit<
      FormControlProps<string | Nullish, HTMLDivElement>,
      'onBlur' | 'onChange' | 'onFocus' | 'onKeyDown'
    >,
    TestIdProps {
  isCounterVisible?: boolean;
  isScrollable?: boolean;
  labelActions?: LabelActions;
  maxLength?: number;
  maxRows?: Integer | Nullish;
  minRows?: Integer | Nullish;
  onBlur?: FocusEventHandler<HTMLDivElement>;
  onChange?: (value: string) => void;
  onFocus?: FocusEventHandler<HTMLDivElement>;
  onKeyDown?: KeyboardEventHandler<HTMLDivElement>;
  placeholder?: string;
  rows?: Integer;
  toolbarOptions?: ToolbarOption[];
  warningThreshold?: number;
}
